import React from "react";
import api from "../images/appi.png";
import css from "../images/CSS.svg";
import html from "../images/html.png";
import js from "../images/js.png";
import mui from "../images/mui.png";
import react from "../images/React.png";
import sass from "../images/scss.png";
import styled from "../images/styled.png";
import tailwind from "../images/tailwinddd.png";
import typescript from "../images/Typescript.png";
import redux from "../images/redux.png";
import query from "../images/query.png";
import bootstrap from "../images/bootstrap-logo.svg";
import node from "../images/node.png";
import express from "../images/express.png";
import mongo from "../images/mongodbb.svg";
import mysql from "../images/mysql.png";
import next from "../images/next.png";
import angular from "../images/Angular.png";

const Skills = () => {
  const front = [
    {
      img: js,
      name: "JavaScript",
    },

    {
      img: typescript,
      name: "TypeScript",
    },

    {
      img: react,
      name: "React.js",
    },
    {
      img: next,
      name: "Next.js",
    },
    {
      img: node,
      name: "Node.js",
    },

    {
      img: angular,
      name: "Angular",
    },
    {
      img: express,
      name: "Express.js",
    },
    {
      img: mongo,
      name: "Mongo DB",
    },

    {
      img: mysql,
      name: "MySQL",
    },

    {
      img: mui,
      name: "Mui Material",
    },

    {
      img: tailwind,
      name: "Tailwind CSS",
    },
    {
      img: bootstrap,
      name: "Bootstrap",
    },
    {
      img: sass,
      name: "SASS",
    },

    {
      img: styled,
      name: "Styled Components",
    },

    {
      img: redux,
      name: "React Redux",
    },

    {
      img: query,
      name: "React Query",
    },

    {
      img: api,
      name: "API Integrations",
    },

    {
      img: html,
      name: "HTML",
    },

    {
      img: css,
      name: "CSS",
    },
  ];

  const devtools = ["Git", "GitHub", "HubSpot", "npm", "Webpack", "Vite"];

  const plan = [];

  return (
    <div className="skill-page">
      <div className="front-box">
        <h3>Tech-Skills</h3>
        <p>Node.js|Next.js|MongoDB|express are self learned skills</p>
        <ul>
          {front.map((item) => {
            return (
              <li>
                <img src={item.img} alt="Lang" />
                <p>{item.name}</p>
              </li>
            );
          })}
        </ul>
      </div>

      <div className="dev-box">
        <h3>Developer Tools</h3>

        <ul>
          {devtools.map((item) => {
            return <li>{item}</li>;
          })}
        </ul>
      </div>

      {plan && (
        <div className="plan-box">
          <h3>Plan for the nearest future</h3>
          <ul>
            {plan.map((item) => {
              return (
                <li>
                  <img src={item.img} alt="Lang" />
                  <p>{item.name}</p>
                </li>
              );
            })}
          </ul>
        </div>
      )}
    </div>
  );
};

export default Skills;
